import { LngLat, Margin, YMapLocationRequest } from '@yandex/ymaps3-types';

export const DEFAULT_CLUSTER_GRID_SIZE = 128;
export const DEFAULT_ZOOM_VALUE = 12;
export const DEFAULT_SELECT_POINT_ZOOM_VALUE = 18;
export const DEFAULT_CENTER_VALUE: LngLat = [37.617698, 55.755864];
export const MARGIN: Margin = [220, 100, 100, 330];
export const MOBILE_MARGIN: Margin = [10, 10, 10, 10];

export const LOCATION: YMapLocationRequest = {
  center: DEFAULT_CENTER_VALUE,
  zoom: DEFAULT_ZOOM_VALUE
};

export const COMMON_LOCATION_PARAMS: Partial<YMapLocationRequest> = {
  easing: 'ease-in-out',
  duration: 1000
};
